import { render, staticRenderFns } from "./live_list.vue?vue&type=template&id=5e19a6c4&scoped=true"
import script from "./live_list.vue?vue&type=script&lang=js"
export * from "./live_list.vue?vue&type=script&lang=js"
import style0 from "./live_list.vue?vue&type=style&index=0&id=5e19a6c4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e19a6c4",
  null
  
)

export default component.exports